export default {
  namespaced: true,
  state: () => ({
    conditions: null,
    obligatory_labtests: null,
    question: null,
    recommended_labtests: null
  }),
  getters: {
    conditions: state => state.conditions,
    obligatory_labtests: state => state.obligatory_labtests,
    question: state => state.question,
    recommended_labtests: state => state.recommended_labtests
  },
  mutations: {
    set (state, {
      conditions,
      obligatory_labtests,
      question,
      recommended_labtests
    }) {
      state.conditions = conditions
      state.obligatory_labtests = obligatory_labtests
      state.question = question
      state.recommended_labtests = recommended_labtests
    },
    reset (state) {
      state.conditions = null
      state.obligatory_labtests = null
      state.question = null
      state.recommended_labtests = null
    }
  }
}
